import type { HostActions } from '@makemydeal/dr-activities-change-vehicle';
import { CDL_V3_EVENT } from '@makemydeal/dr-activities-change-vehicle';
import { buyThisVehicle, handleCancelEvent } from '@makemydeal/dr-sales-checkin-store';

export const hostActions: HostActions = {
    navigateToDashboard: handleCancelEvent,
    switchVehicle: buyThisVehicle,
    forwardCDLEvent: (cdlPayload: any) => ({
        type: CDL_V3_EVENT,
        payload: cdlPayload
    })
};
